import { render, staticRenderFns } from "./ExpenseCreateUpdate.vue?vue&type=template&id=555188f0&"
import script from "./ExpenseCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./ExpenseCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports